import {ThemeProvider,Container, Box, Typography, CardContent, Paper} from '@mui/material';
import theme from "../../theme";
import blob from '../../assets/blob2.svg'

// import {NavLink} from "react-router-dom";


const ItemProduct = ({product}) => {

    return(

        <ThemeProvider theme={theme}>
            <Container
                       component={Paper}
                       sx={{
                           // paddingTop:'16px',
                           border:'1px solid #F3D188',
                            // width: '350px',
                            width: '100%'
                       }}>
                <Box>
                    <CardContent sx={{
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'space-between',
                        flexGrow: 1,
                        // height:'540px'
                        // height:'740px'
                    }} >

                        <Typography variant="body2"
                                    sx={{
                                        mr: 3,
                                        // ml:{ xs: 5, md: 17, xl:15 },
                                        mt:{ xs: 2, xl:3 },
                                        fontSize: 16,
                                        fontWeight: 600,                                        
                                    }}>
                            {product.name}  
                        </Typography>

                        <Box sx={{
                            display:'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            justifyContent:'space-between',
                            flexGrow: 1,
                            gap: 2,
                            // height:'540px'
                            
                    }}>

                        <Box   
                                        //przekierowanie do sklepu
                                        // component={NavLink}
                                        // to={`/shop`}
                                        sx={{
                                                // mt: { xs: 2, xl: 3 }, //to samo
                                                // backgroundImage: `url(${blob})`, //to samo
                                                // backgroundRepeat: 'no-repeat', //too samo
                                                // backgroundSize: 'contain',
                                                // backgroundPosition: 'center',
                                                // display: 'flex', //tp samo
                                                // justifyContent: 'center', //tp samo
                                                // alignItems: 'center', //tp samo
                                                // width: { xs: '100%', sm: '50%' },
                                                // maxHeight: '250px',
                                                // p: { xs: 2, sm: 3 },
                                            mr: 3,
                                            mt:{ xs: 2, xl:3 },
                                            backgroundImage: `url(${blob})`,
                                            backgroundRepeat: 'no-repeat',
                                            // backgroundSize: 'cover',
                                            backgroundSize: { xs: 'contain', md: 'contain' },
                                            backgroundPosition: 'center',
                                            display:'flex',
                                            justifyContent:'center',
                                            width: { xs: '100%', md: '50%', xl:'30%' },
                                            // backgroundPositionY:'-10px',
                                            // backgroundPositionX:'-10px',
                                            alignItems: 'center',           
                                            maxheight: '250px',                
                                            padding: '30px',
                                            paddingRight: '40px'
                                            
                                       
                                    }}>
                            <img src={product.img} alt ={product.name}
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '250px',
                                objectFit: 'contain',
                            //    maxHeight:'250px',
                            //    objectFit: 'contain'
                            }}/>
                        </Box>

                        <Box sx={{
                            display:'flex',
                            flexDirection:'column',
                            width: { xs: '100%', md: '50%',xl:'70%' },
                            // justifyContent:'space-between',
                            flexGrow: 1,
                            // height:'540px',
                            alignItems: 'flex-end',
                            width: '100%',
                         }}>

                        <Typography variant="body2"
                                    sx={{
                                        // mr: 3,
                                        // ml:{ xs: 5, md: 17, xl:15 },
                                        mt:{ xs: 2, xl:3 },
                                        fontSize: { xs: 12, sm:14 },
                                        fontWeight: 400,
                                        minHeight:'120px',
                                        textAlign:'justify',
                                        width: '100%',
                                    }}>
                            {product.description}
                        </Typography>

                        <Typography variant="body2"
                                        sx={{
                                            // mr: 3,
                                            // ml:{ xs: 5, md: 17, xl:15 },
                                            mt:{ xs: 2, xl:3 },
                                            fontSize: { xs: 13, sm:16 },
                                            fontWeight: 600,
                                            textAlign:'right',
                                            whiteSpace: 'pre-line',
                                            alignSelf: 'flex-end', 
                                        }}>
                                Cena: {product.price}
                            </Typography>
                            </Box>
                            </Box>

                    </CardContent>
                </Box>
            </Container >
        </ThemeProvider >
    )
}

export default ItemProduct;